function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.73544 11.2333C6.22629 10.0019 6.95746 8.90045 7.92898 7.92893C8.9005 6.95742 10.0019 6.22624 11.2333 5.7354C12.4647 5.24455 13.7211 4.99951 15.0025 5.00026C16.2839 5.00101 17.5378 5.24476 18.7642 5.73153C19.9906 6.21829 21.0902 6.94799 22.0628 7.92064C23.0465 8.90435 23.7818 10.0094 24.2685 11.2359C24.7553 12.4623 24.999 13.7162 24.9998 14.9976C25.0005 16.279 24.7555 17.5353 24.2646 18.7667C23.7738 19.9981 23.0426 21.0996 22.0711 22.0711C21.0996 23.0426 19.9982 23.7738 18.7668 24.2646C17.5354 24.7554 16.279 25.0005 14.9976 24.9997C13.7162 24.999 12.4623 24.7552 11.2359 24.2685C10.0095 23.7817 8.9044 23.0465 7.92069 22.0628C6.94803 21.0901 6.21833 19.9906 5.73157 18.7641C5.24481 17.5377 5.00106 16.2838 5.00031 15.0024C4.99955 13.721 5.2446 12.4647 5.73544 11.2333ZM20.4935 16.1216L20.4922 13.9013L16.1013 13.8822L16.0987 9.50781L13.8784 9.50651L13.881 13.8809L9.50659 13.8783L9.50789 16.0986L13.8823 16.1012L13.9014 20.4922L16.1217 20.4935L16.1026 16.1025L20.4935 16.1216Z",
  fill: "currentColor"
});

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.8130a502.svg";
export { ForwardRef as ReactComponent };